import React from "react";
import { TextField, Button, TableRow, TableCell } from "@mui/material";
import Switch from "@mui/material/Switch";

function CargoAdd1({
  cargoTypeAddOptions,
  weightUnitOptions,
  dimensionUnitOptions,
  onCargoRemove,
  element,
  index,
  onChange,
  length,
}) {
  return (
    <TableRow className="cargoAddTableCell">
      <TableCell>
        <select
          className={
            element.pkgType
              ? `form-control selectOptions selectOptionsSelected`
              : `form-control selectOptions`
          }
          value={element.pkgType}
          onChange={(e) => {
            onChange(index, "pkgType", e.target.value);
          }}
        >
          <option value="" disabled>
            Select Type
          </option>
          {cargoTypeAddOptions.map((options) => (
            <option key={options} value={options}>
              {options}
            </option>
          ))}
        </select>
      </TableCell>

      <TableCell>
        <TextField
          variant="standard"
          label={<div className="inquiryLabel">Quantity</div>}
          size="small"
          type="number"
          pattern="[0-9.]*"
          value={element.quantity ? element.quantity : null}
          onChange={(event) => {
            if (parseInt(event.target.value) < 0) {
              onChange(
                index,
                "quantity",
                Math.abs(parseInt(event.target.value))
              );
            } else {
              onChange(index, "quantity", event.target.value);
            }
          }}
        />
      </TableCell>
      <TableCell>
        <select
          className={
            element.dimensionUnit
              ? `form-control selectOptions selectOptionsSelected`
              : `form-control selectOptions`
          }
          value={element.dimensionUnit}
          onChange={(e) => {
            onChange(index, "dimensionUnit", e.target.value);
          }}
        >
          <option value="" disabled>
            Select Unit
          </option>
          {dimensionUnitOptions.map((options) => (
            <option key={options} value={options}>
              {options}
            </option>
          ))}
        </select>
      </TableCell>
      <TableCell>
        <TextField
          variant="standard"
          label={<div className="inquiryLabel">Length</div>}
          size="small"
          type="number"
          pattern="[0-9.]*"
          value={element.length ? element.length : null}
          onChange={(event) => {
            if (parseInt(event.target.value) < 0) {
              onChange(index, "length", Math.abs(parseInt(event.target.value)));
            } else {
              onChange(index, "length", event.target.value);
            }
          }}
        />
      </TableCell>
      <TableCell>
        <TextField
          variant="standard"
          label={<div className="inquiryLabel">Width</div>}
          size="small"
          type="number"
          pattern="[0-9.]*"
          value={element.width ? element.width : null}
          onChange={(event) => {
            if (parseInt(event.target.value) < 0) {
              onChange(index, "width", Math.abs(parseInt(event.target.value)));
            } else {
              onChange(index, "width", event.target.value);
            }
          }}
        />
      </TableCell>
      <TableCell>
        <TextField
          variant="standard"
          label={<div className="inquiryLabel">Height</div>}
          size="small"
          type="number"
          pattern="[0-9.]*"
          value={element.height ? element.height : null}
          onChange={(event) => {
            if (parseInt(event.target.value) < 0) {
              onChange(index, "height", Math.abs(parseInt(event.target.value)));
            } else {
              onChange(index, "height", event.target.value);
            }
          }}
        />
      </TableCell>
      <TableCell>
        <select
          className={
            element.weightUnit
              ? `form-control selectOptions selectOptionsSelected`
              : `form-control selectOptions`
          }
          value={element.weightUnit}
          onChange={(e) => {
            onChange(index, "weightUnit", e.target.value);
          }}
        >
          <option value="" disabled>
            Select Unit
          </option>
          {weightUnitOptions.map((options) => (
            <option key={options} value={options}>
              {options}
            </option>
          ))}
        </select>
      </TableCell>
      <TableCell>
        <TextField
          variant="standard"
          label={<div className="inquiryLabel">Weight Per </div>}
          size="small"
          type="number"
          pattern="[0-9.]*"
          value={element.weight ? element.weight : null}
          onChange={(event) => {
            if (parseInt(event.target.value) < 0) {
              onChange(index, "weight", Math.abs(parseInt(event.target.value)));
            } else {
              onChange(index, "weight", event.target.value);
            }
          }}
        />
      </TableCell>

      <TableCell>
        <Switch
          checked={element.stackable === "Yes"}
          onChange={(event) => {
            const value = event.target.checked ? "Yes" : "No";
            onChange(index, "stackable", value);
          }}
          inputProps={{ "aria-label": "controlled" }}
        />
      </TableCell>
      <TableCell>
        {length > 1 ? (
          <Button onClick={() => onCargoRemove(index)}>Remove</Button>
        ) : null}
      </TableCell>
    </TableRow>
  );
}

export default CargoAdd1;
